import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  connect() {
    window.addEventListener("applicationWillEnterForeground", this.handleForegrounding)
  }

  disconnect() {
    window.removeEventListener("applicationWillEnterForeground", this.handleForegrounding)
  }

  handleForegrounding() {
    Turbo.visit(window.location.href, { action: "replace" })
  }
}
